import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./ulits/request";
import { createPinia } from "pinia";
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// import { Image as VanImage } from 'vant';
import {
  Icon,
  Tab,
  Tabs,
  NumberKeyboard,
  Skeleton,
  SkeletonTitle,
  SkeletonImage,
  SkeletonAvatar,
  SkeletonParagraph,
  Progress,
  Popup,
  Field,
  Checkbox,
  CellGroup,
  Notify,
  PullRefresh,
  Cell,
  DropdownMenu,
  DropdownItem,
  List,
  Toast,
  RadioGroup,
  Radio,
  Uploader,
  Popover,
  Swipe,
  SwipeItem,
  Overlay,
  Switch,
  Dialog,
  Collapse,
  CollapseItem,
} from "vant";
import "vant/lib/index.css";

import "swiper/css/swiper.css";

const app = createApp(App);
const plugins = [
  router,
  createPinia(),
  Icon,
  Tab,
  Tabs,
  Skeleton,
  Collapse,
  CollapseItem,
  NumberKeyboard,
  SkeletonTitle,
  SkeletonImage,
  SkeletonAvatar,
  SkeletonParagraph,
  Popup,
  Field,
  Checkbox,
  CellGroup,
  Notify,
  PullRefresh,
  Cell,
  DropdownMenu,
  DropdownItem,
  List,
  Toast,
  RadioGroup,
  Radio,
  Uploader,
  Popover,
  Swipe,
  SwipeItem,
  Overlay,
  Switch,
  Progress,
  // vConsole,
  Dialog,
];

plugins.forEach((plugin) => {
  app.use(plugin);
});

app.mount("#app");
